import React, { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import useApi from '../api';
import { ToastContainer, toast } from 'react-toastify';
import toastConfig from '../config/Toast';
import 'react-toastify/dist/ReactToastify.css';
import Spinner from '../documentation/Spinner';

const PageModal: React.FC<{ isOpen: boolean; closeModal: () => void; pageId: string }> = ({ isOpen, closeModal, pageId }) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<any>(null);
  const { get } = useApi();

  useEffect(() => {
    const fetchPageDetails = async () => {
      try {
        setLoading(true);
        const data = await get(`/pages/${pageId}`);
        console.log('Page details:', data.data);
        setPage(data.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching page details:', error);
        toast.error('Error fetching page details', toastConfig);
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchPageDetails();
    }
  }, [isOpen, pageId]);

  const renderChunks = (chunks: any) => {
    return (
      <ul className="list-inside space-y-4 mt-4">
        {chunks.map((chunk: any, index: number) => (
          <li key={index} className="rounded-lg shadow-sm bg-slate-50 border p-4 mt-1 text-sm text-slate-900">
            <span>{chunk.text}</span>
            <div className='font-semibold mt-2'>Tokens: {chunk.tokens}</div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-xl text-center font-medium leading-6 text-slate-900 mb-4">
                  Page Details
                </Dialog.Title>
                {loading ? (
                  <div className="flex justify-center">
                    <Spinner />
                  </div>
                ) : (
                  page && (
                    <div>
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-700">URL</label>
                        <p className="mt-1 text-sm text-slate-900">{page.url}</p>
                      </div>
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-700">Title</label>
                        <p className="mt-1 text-sm text-slate-900">{page.title}</p>
                      </div>
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-700">Meta Description</label>
                        <p className="mt-1 text-sm text-slate-900">{page.meta_description}</p>
                      </div>
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-700">Last Indexed</label>
                        <p className="mt-1 text-sm text-slate-900">{page.indexed_at}</p>
                      </div>
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-700">Extracted Text</label>
                        <div className="mt-1 text-sm text-slate-900">
                        {renderChunks(page.page_data.chunks)}
                        </div>
                      </div>
                    </div>
                  )
                )}
                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-slate-100 px-4 py-2 text-sm font-medium text-slate-900 hover:bg-slate-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default PageModal;
